import { AccordianItem } from 'components/Accordian';

import FAQContent from './FAQContent';
import FAQHeader from './FAQHeader';

const WRAPPER_CLASS_NAME = 'border border-neutral-300 rounded-xl';

const ITEMS = [
  {
    id: 'who-is-ideal4fiance',
    header: 'Who is Ideal4Finance?',
    content:
      'Ideal4Finance is a credit broker founded in 2008, on a mission to help businesses offer flexible finance solutions to their customers making high-value purchases more accessible through simple, manageable payment plans.',
  },
  {
    id: 'how-finance-works',
    header: 'How does the finance option work?',
    content:
      "Choose your preferred APR and term to view your monthly payments, then complete a short application with your personal, employment, and income details. Our lenders will complete a hard credit search, and most customers get an instant decision. Once approved, your installer can begin work. Upon completion, we'll ask you to sign a Satisfaction Note, after which we pay the installer directly, and your repayments start within 30 days.",
  },
  {
    id: 'affect-credit-score',
    header: 'Will applying for finance affect my credit score?',
    content:
      'Yes, our lenders will complete a hard credit search as part of your application. This will be visible to other lenders and may have a short-term impact on your credit score. Most customers still receive an instant decision, and your credit file will only be impacted if you proceed with the application.',
  },
  {
    id: 'extra-repayments-early',
    header: 'Can I make extra payments or pay off the loan early?',
    content:
      "Yes - you can make overpayments or settle the loan in full at any time. If you pay in full, there is only an early-settlement fee equal to 58 days of interest (and if your loan is 0% APR, there's no fee at all).",
  },
  {
    id: 'when-payment-taken',
    header: 'When will the first payment be taken?',
    content:
      'If approved, payments will start on your preferred payment date within 30 days of you signing the satisfaction note on job completion.',
  },
  {
    id: 'change-my-mind',
    header: 'What if I change my mind after applying for finance?',
    content:
      'This will depend on the lender you choose and will be mentioned in your lender agreement. If you have any further queries, please contact our loans team on 020 3617 4647.',
  },
];

export const ACCORDIAN_ITEMS: AccordianItem[] = ITEMS.map((item) => ({
  id: item.id,
  button: <FAQHeader id={item.id} text={item.header} />,
  content: <FAQContent text={item.content} />,
  wrapperClassName: WRAPPER_CLASS_NAME,
}));
